import queryString from "query-string";

import { PUBLIC_ROUTES, ROUTES } from "src/constants";
import { extractEntityIdField } from "./helpers";
import { getRegExpValue } from "src/constants/form.validation";
import { appConfig } from "src/config";

export const isPublicRoute = (routePathname: ROUTES): boolean =>
  PUBLIC_ROUTES.includes(routePathname);

export const getUrlSerializedCaseId = (caseId: string): string => {
  if (Number(caseId)) {
    return JSON.stringify({ id: Number(caseId), type: "Case" });
  }

  return caseId;
};

const URL_ID_REGEX = appConfig.URL_ID_REGEX
  ? getRegExpValue(appConfig.URL_ID_REGEX)
  : null;

export const isUrlWithSerializedId = (url: string): boolean =>
  !!URL_ID_REGEX && URL_ID_REGEX.test(url);

const getPageRedirectPathNameAlias = (pathname: string): string =>
  pathname
    .split("/")
    .filter(Boolean)
    .map((pathnamePart) => {
      if (isUrlWithSerializedId(pathnamePart)) {
        return extractEntityIdField(decodeURIComponent(pathnamePart));
      }

      return pathnamePart;
    })
    .filter(Boolean)
    .join("/");

const getPageRedirectSearchParamsAlias = (searchParams: string): string => {
  const queryParams = queryString.parse(searchParams);

  const parsedParams = Object.entries(queryParams).reduce(
    (acc, [key, value]) => {
      const encodedValue =
        typeof value === "string" ? encodeURIComponent(value) : null;

      if (encodedValue && isUrlWithSerializedId(encodedValue)) {
        return {
          ...acc,
          [key]: extractEntityIdField(decodeURIComponent(encodedValue))
        };
      }

      return {
        ...acc,
        [key]: value
      };
    },
    {}
  );

  return queryString.stringify(parsedParams);
};

export const getPageRedirectUrlAlias = (
  pathname: string,
  searchParams: string
): string => {
  const redirectPathname = getPageRedirectPathNameAlias(pathname);
  const redirectSearchParams = getPageRedirectSearchParamsAlias(searchParams);

  return `/${redirectPathname}?${redirectSearchParams}`;
};

export const isKonfirRedirectPage = (pathname: string): boolean =>
  pathname === (ROUTES.KONFIR_REDIRECT as string);
